import { motion } from "framer-motion";

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/globex-logo.png"
      alt="Globex logo"
      width={compact ? 34 : 40}
      height={compact ? 34 : 40}
      className="rounded-xl bg-panel/60 p-1 ring-1 ring-line"
    />
    <div className="leading-none">
      <span className="font-display text-lg font-extrabold tracking-tight text-slate-100">
        Glo<span className="text-gold">bex</span>
      </span>
      <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500">
        Sdn Bhd &middot; KL &middot; SG
      </span>
    </div>
  </div>
);

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : "text-left"}>
    <p className="font-mono text-xs uppercase tracking-[0.35em] text-alpha">{eyebrow}</p>
    <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 max-w-2xl text-sm leading-relaxed text-slate-400 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
